module.exports = __webpack_public_path__ + "static/media/EnrichGoodOptimized.9305cf4c.jp2";